// Font loader utility for Turkish character support in jsPDF
// Web uygulaması için otomatik font yükleme çözümü
// Font converter dosyaları otomatik yüklenir

import robotoNormal from './fonts/roboto-normal.js';
import robotoBold from './fonts/roboto-bold.js';

let robotoFontLoaded = false;

/**
 * Check if Roboto font is loaded
 */
export const isRobotoLoaded = () => robotoFontLoaded;

/**
 * Font converter dosyalarını yükle ve jsPDF'e ekle
 */
const loadRobotoFromConverter = async (doc) => {
  try {
    // Font converter dosyalarından font verilerini al
    const normalFontData = robotoNormal;
    const boldFontData = robotoBold;

    if (!normalFontData || !boldFontData) {
      console.warn('Font data is missing');
      return false;
    }

    // Check if font data looks valid (should be base64, not HTML)
    // Font data should start with base64 characters, not HTML tags
    const normalStr = String(normalFontData);
    if (normalStr.length < 100 || normalStr.includes('<!DOCTYPE') || normalStr.includes('<html')) {
      console.warn('Font data appears to be invalid (contains HTML instead of font data). Please re-convert the fonts.');
      return false;
    }

    // jsPDF'e ekle
    doc.addFileToVFS('roboto-normal.ttf', normalFontData);
    doc.addFont('roboto-normal.ttf', 'roboto', 'normal');
    
    doc.addFileToVFS('roboto-bold.ttf', boldFontData);
    doc.addFont('roboto-bold.ttf', 'roboto', 'bold');
    
    // Fontu kullan
    doc.setFont('roboto', 'normal');
    robotoFontLoaded = true;
    console.log('✅ Roboto font loaded successfully');
    return true;
  } catch (error) {
    console.warn('Error loading Roboto fonts from converter files:', error);
    robotoFontLoaded = false;
    return false;
  }
};

/**
 * Initialize font support for Turkish characters
 * Web uygulaması için otomatik font yükleme
 * 
 * Öncelik sırası:
 * 1. Font converter dosyaları (en güvenilir)
 * 2. Times font (fallback - kısmi Türkçe desteği)
 */
export const initializeTurkishFont = async (doc) => {
  try {
    // Font converter dosyalarını yükle (en güvenilir)
    const loaded = await loadRobotoFromConverter(doc);
    
    if (loaded) {
      return true;
    }

    // Fallback to 'times' font which has better Unicode support than 'helvetica'
    // This provides partial Turkish character support
    doc.setFont('times', 'normal');
    return true;
  } catch (error) {
    // Hata durumunda varsayılan fontu kullan
    try {
      doc.setFont('times', 'normal');
      return true;
    } catch (e) {
      return false;
    }
  }
};

// Helper to ensure text encoding is correct for Turkish characters
export const ensureUTF8 = (text) => {
  if (!text) return text;
  // Ensure the text is properly encoded as UTF-8 string
  // This preserves Turkish characters: ç, ğ, ı, ö, ş, ü, İ, Ş, Ğ, Ü, Ö, Ç
  const textStr = String(text);
  
  // Normalize Unicode characters to ensure proper encoding
  // This helps with Turkish character rendering
  try {
    return textStr.normalize('NFC'); // Normalize to Canonical Composition
  } catch (e) {
    // Fallback if normalize is not supported
    return textStr;
  }
};
